import React, { useState } from "react";
import {
  Row,
  FormGroup,
  Col,
  Label,
  Accordion,
  Button,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Input,
  InputGroup,
  Offcanvas,
  OffcanvasBody,
  InputGroupText,
  Container,
} from "reactstrap";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { Field, Formik } from "formik";
import QRSacnIcon from "../../../assets/icon/scan-qr-icon.svg";
import productImage from "../../../assets/images/product-image.png";
import CloseIcon from "../../../assets/icon/chatClose.svg";

import EditPatientDetails from "../EditPatientDetails";

import leftArrow from "../../../assets/icon/left-arrow.svg";
import checkIcon from "assets/icon/check-icon.svg";

const PackagingInfoDetails = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [allergies, setAllergies] = useState([{ id: 1, data: "Venlafaxine" }]);

  const [confirm, setConfirm] = useState(false);
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("1");
  const [openFour, setOpenFour] = useState("1");
  const [patientEditDetails, setPatientEditDetails] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    option1: "",
  });
  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    if (value==='')return
    setSelectedOptions((prevOptions) => (
      
      {

      ...prevOptions,
      [name]: value,
    }));
  };

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };
  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };
  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };
  const togglebtnFour = (id) => {
    if (openFour === id) {
      setOpenFour();
    } else {
      setOpenFour(id);
    }
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate("/workflow-packaging");
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const items = [
    {
      src: productImage,
      key: 1,
    },
    {
      src: productImage,
      key: 2,
    },
  ];
  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {" "}
        <img
          src={item.src}
          style={{ display: "flex", justifyContent: "center", margin: "auto" }}
        />
      </CarouselItem>
    );
  });

  const handleDeleteAl = (id) => {
    setAllergies((prev) => prev.filter((item) => item.id !== id));
  };
  const handleSubmitAl = () => {
    if (allergies=='')return
    setAllergies((prev) => [
      ...prev,
      { id: Date.now(), data: selectedOptions.data },
    ]);
    setSelectedOptions((prev) => ({ ...prev, data: "" }));
  };
  return (
    <>
      <Container fluid className="details-page-body p-3 ">
        <Container fluid>
          <div
            className="d-flex gap-2 orderEntry-heading pb-2 mb-2"
            style={{ borderBottom: "1px solid #D3D3D3" }}
          >
            <img
              src={leftArrow}
              className="cursor-pointer left-arrow-btn"
              onClick={goBack}
            />
            <div className="heading-text">Order Details ( RX-6152675 )</div>
          </div>
          <div className="packaging-accordian-div">
            <div className="p-3 mb-2" style={{ backgroundColor: "#DBCAD8" }}>
              <Row>
                <div className="scan-code">Scan Barcode</div>
                <Col sm={12} md={8} lg={8}>
                  <Formik className="mb-1 mb-0">
                    <InputGroup style={{ backgroundColor: "white" }}>
                      <Input
                        className="inputText"
                        id="clamsone"
                        name="data"
                        type="text"
                        value={selectedOptions.data}
                        onChange={handleChangeOption}
                        placeholder="Scan Product Barcode"
                        autoComplete="off"
                      />
                      <div className="scan-btn"    onClick={handleSubmitAl}>
                        <img
                          className=""                       
                          src={QRSacnIcon}
                          alt="not available"
                        />
                        Scan
                      </div>
                    </InputGroup>
                  </Formik>
                  <div className="d-flex justify-content-start align-items-center direction-row gap-2">
                    {allergies.map((name) => (
                      <div className={name.data?'allergies-add-data-pack':""} key={name.id}>
                        <div onClick={() => handleDeleteAl(name.id)}>
                          <img
                            src={name.data?CloseIcon:''}
                            alt=""
                            className="cursor-pointer"
                          />
                        </div>
                        <div>{name.data}</div>
                      </div>
                    ))}
                  </div>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Formik>
                    <FormGroup className="controls textarea_info search-flex  bg-white">
                      <InputGroup className="form-control ">
                        <Field
                          as="select"
                          name="option1"
                          id="option"
                          value={setSelectedOptions.option1}
                          onChange={handleChangeOption}
                        >
                          <option value="" label="Single Package" />
                          <option value="option1" label="Option 1" />
                          <option value="option2" label="Option 2" />
                          <option value="option3" label="Option 3" />
                        </Field>
                      </InputGroup>
                    </FormGroup>
                  </Formik>
                </Col>
              </Row>
              <Row>
                <div className="or-divider">
                  <div className="line"></div>
                  <div style={{ color: "#757575" }}>Or</div>
                  <div className="line"></div>
                </div>
              </Row>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  {" "}
                  <Label className="mb-2">Manual Entry</Label>
                </div>

                <div>
                  <Button
                    disabled={true}
                    color="transparent"
                    className="reset"
                    style={{
                      float: "right",
                      backgroundColor: "transparent",
                      border: "none",
                      verticalAlign: "middle",
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </div>
              <Row>
                <Col>
                  <InputGroup className="remove-outline bg-white  mb-0 mb-1">
                    <Input
                      id="startDate"
                      name="NDC/UPC"
                      placeholder="NDC/UPC"
                      autoComplete="off"
                      className="input-spacing-left mb-0"
                    />
                    <InputGroupText className="date-img">
                      <img src={checkIcon} alt="" />
                    </InputGroupText>
                  </InputGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-0 mb-1">
                    <InputGroup className="remove-outline   bg-white">
                      <Input
                        id="startDate"
                        name="startDate"
                        placeholder="Serial Number"
                        autoComplete="off"
                        className="input-spacing-left mb-0"
                      />
                      <InputGroupText className="date-img">
                        <img src={checkIcon} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup className="mb-0 mb-1">
                    <InputGroup className="remove-outline  bg-white  ">
                      <Input
                        id="startDate"
                        name="lot"
                        placeholder="Lot Number"
                        autoComplete="off"
                        className="input-spacing-left"
                      />
                      <InputGroupText className="date-img">
                        <img src={checkIcon} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className=" mb-0 mb-1">
                    <InputGroup className="remove-outline   bg-white">
                      <Input
                        name="GTIN"
                        placeholder="GTIN"
                        autoComplete="off"
                        className="input-spacing-left"
                      />
                      <InputGroupText className="date-img">
                        <img src={checkIcon} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <InputGroup className="remove-outline   bg-white mb-0 mb-1 ">
                      <Input
                        name="expiration"
                        placeholder="Expiration Date"
                        autoComplete="off"
                        className="input-spacing-left"
                      />
                      <InputGroupText className="date-img">
                        <img src={checkIcon} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup></FormGroup>
                </Col>
              </Row>
            </div>
            <Accordion open={openOne} toggle={togglebtnOne}>
              <AccordionItem>
                <AccordionHeader targetId="1">Product Details </AccordionHeader>
                <AccordionBody accordionId="1">
                  <Row>
                    <Col md={6} style={{ borderRight: "1px solid #D3D3D3" }}>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Product Number</div>
                          <div className="patient-details">0029-0238-90</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Product Name</div>
                          <div className="patient-details">
                            Venlafaxine ER 150 Capusle
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Manufacturer</div>
                          <div className="patient-details">Teva</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Quantity On Hand</div>
                          <div className="patient-details">10</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">NDC (Center)</div>
                          <div className="patient-details">42799096201</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">340B</div>
                          <div className="patient-details">X</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md={4}>
                          <div className="pdetails">Description</div>
                          <div className="patient-details">
                            Off-White, Oblong, capsule, 302 IA150
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} sm={12}>
                      <Row>
                        <Col>
                          <div>
                            <Carousel
                              activeIndex={activeIndex}
                              next={next}
                              previous={previous}
                            >
                              <CarouselIndicators
                                style={{
                                  position: "relative",
                                  color: "red",
                                  top: "220px",
                                }}
                                items={items}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex}
                              />
                              {slides}
                              <CarouselControl
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={previous}
                              ></CarouselControl>

                              <CarouselControl
                                direction="next"
                                directionText="Next"
                                onClickHandler={next}
                              />
                            </Carousel>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
            <Accordion open={false} toggle={togglebtnTwo} className="mt-2">
              <AccordionItem>
                <AccordionHeader targetId="4">Order Overview </AccordionHeader>
                <AccordionBody accordionId="4">
                  <Row>
                    <Col md={6} style={{ borderRight: "1px solid #D3D3D3" }}>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Product Number</div>
                          <div className="patient-details">0029-0238-90</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Product Name</div>
                          <div className="patient-details">
                            Venlafaxine ER 150 Capusle
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Manufacturer</div>
                          <div className="patient-details">Teva</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Quantity On Hand</div>
                          <div className="patient-details">10</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">NDC (Center)</div>
                          <div className="patient-details">42799096201</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">340B</div>
                          <div className="patient-details">X</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md={4}>
                          <div className="pdetails">Description</div>
                          <div className="patient-details">
                            Off-White, Oblong, capsule, 302 IA150
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} sm={12}>
                      <Row>
                        <Col>
                          <div>
                            <Carousel
                              activeIndex={activeIndex}
                              next={next}
                              previous={previous}
                            >
                              <CarouselIndicators
                                style={{
                                  position: "relative",
                                  color: "red",
                                  top: "220px",
                                }}
                                items={items}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex}
                              />
                              {slides}
                              <CarouselControl
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={previous}
                              ></CarouselControl>

                              <CarouselControl
                                direction="next"
                                directionText="Next"
                                onClickHandler={next}
                              />
                            </Carousel>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
            <Accordion open={false} toggle={togglebtnThree} className="mt-2">
              <AccordionItem>
                <AccordionHeader targetId="5">
                  Packaging Details{" "}
                </AccordionHeader>
                <AccordionBody accordionId="5">
                  <Row>
                    <Col md={6} style={{ borderRight: "1px solid #D3D3D3" }}>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Product Number</div>
                          <div className="patient-details">0029-0238-90</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Product Name</div>
                          <div className="patient-details">
                            Venlafaxine ER 150 Capusle
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Manufacturer</div>
                          <div className="patient-details">Teva</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Quantity On Hand</div>
                          <div className="patient-details">10</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">NDC (Center)</div>
                          <div className="patient-details">42799096201</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">340B</div>
                          <div className="patient-details">X</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md={4}>
                          <div className="pdetails">Description</div>
                          <div className="patient-details">
                            Off-White, Oblong, capsule, 302 IA150
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} sm={12}>
                      <Row>
                        <Col>
                          <div>
                            <Carousel
                              activeIndex={activeIndex}
                              next={next}
                              previous={previous}
                            >
                              <CarouselIndicators
                                style={{
                                  position: "relative",
                                  color: "red",
                                  top: "220px",
                                }}
                                items={items}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex}
                              />
                              {slides}
                              <CarouselControl
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={previous}
                              ></CarouselControl>

                              <CarouselControl
                                direction="next"
                                directionText="Next"
                                onClickHandler={next}
                              />
                            </Carousel>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
            <Accordion open={false} toggle={togglebtnFour} className="mt-2">
              <AccordionItem>
                <AccordionHeader targetId="3">
                  Additional Information{" "}
                </AccordionHeader>
                <AccordionBody accordionId="3">
                  <Row>
                    <Col md={6} style={{ borderRight: "1px solid #D3D3D3" }}>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Product Number</div>
                          <div className="patient-details">0029-0238-90</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Product Name</div>
                          <div className="patient-details">
                            Venlafaxine ER 150 Capusle
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">Manufacturer</div>
                          <div className="patient-details">Teva</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md="4">
                          <div className="pdetails">Quantity On Hand</div>
                          <div className="patient-details">10</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">NDC (Center)</div>
                          <div className="patient-details">42799096201</div>
                        </Col>
                        <Col md="4">
                          <div className="pdetails">340B</div>
                          <div className="patient-details">X</div>
                        </Col>
                      </Row>
                      <Row className="mb-8">
                        <Col md={4}>
                          <div className="pdetails">Description</div>
                          <div className="patient-details">
                            Off-White, Oblong, capsule, 302 IA150
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} sm={12}>
                      <Row>
                        <Col>
                          <div>
                            <Carousel
                              activeIndex={activeIndex}
                              next={next}
                              previous={previous}
                            >
                              <CarouselIndicators
                                style={{
                                  position: "relative",
                                  color: "red",
                                  top: "220px",
                                }}
                                items={items}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex}
                              />
                              {slides}
                              <CarouselControl
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={previous}
                              ></CarouselControl>

                              <CarouselControl
                                direction="next"
                                directionText="Next"
                                onClickHandler={next}
                              />
                            </Carousel>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>
        </Container>

        <Container fluid className="packaging-detials-footer">
          <div className="d-flex">
            <Button
              // disabled={openOne ? false : true}
              color="primary"
              className="reset"
            >
              Scan Override
            </Button>
            <Button
              disabled={openOne ? false : true}
              color="primary"
              className="reset"
            >
              Print / Reprint Label
            </Button>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <Button
              disabled={openOne ? false : true}
              color="primary"
              className="reset"
            >
              Partial Fill
            </Button>
            <Button
              color="secondary"
              className="back-button"
              disabled={openOne ? false : true}
              // className="reset opacity-25"
              onClick={() => setPatientEditDetails(!patientEditDetails)}
            >
              Edit
            </Button>
            <Button
              disabled={openOne ? false : true}
              color="primary"
              className="submit"
            >
              Complete Package
            </Button>
          </div>
        </Container>
      </Container>
      <Offcanvas
        isOpen={patientEditDetails}
        toggle={() => setPatientEditDetails(!patientEditDetails)}
        direction="end"
      >
        <div className="casvas-header p-3 pb-1">
          <div>Edit Details</div>
          <div
            className="cursor-pointer"
            onClick={() => setPatientEditDetails(!patientEditDetails)}
          >
            <img src={CloseIcon} />
          </div>
        </div>
        <div className="section-devider-border-popup"></div>
        <OffcanvasBody>
          <EditPatientDetails />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default PackagingInfoDetails;
